import 'vue';
import './helpers.mjs';
import './config.mjs';
import { b as registerComponent } from './plugins-6d013f3f.mjs';
import './Icon-f1a1777f.mjs';
import './MatchMediaMixin-0c7dfcb9.mjs';
import { s as script, a as script$1 } from './Pagination-ffc73c11.mjs';
export { s as OPagination, a as OPaginationButton } from './Pagination-ffc73c11.mjs';

var index = {
    install(app) {
        registerComponent(app, script);
        registerComponent(app, script$1);
    }
};

export default index;
